import React, { useState } from 'react';
import { LoginForm } from './LoginForm';
import { LoginHeader } from './LoginHeader';
import { useNavigate } from 'react-router-dom';

export const LoginPage: React.FC = () => {
  const [isAdminLogin, setIsAdminLogin] = useState(false);
  const navigate = useNavigate();

  const handleLoginSuccess = () => {
    navigate(isAdminLogin ? '/admin' : '/dashboard');
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] p-6 flex items-center justify-center">
      <div className="w-full max-w-md space-y-8">
        <LoginHeader isAdminLogin={isAdminLogin} />
        
        <LoginForm 
          isAdminLogin={isAdminLogin}
          onSuccess={handleLoginSuccess}
        />

        <div className="text-center space-y-4">
          <button
            onClick={() => setIsAdminLogin(!isAdminLogin)}
            className="text-sm text-purple-300 hover:text-purple-200 transition-colors"
          >
            {isAdminLogin 
              ? '← Voltar para login de membro'
              : 'Acessar como administrador'
            }
          </button>

          {!isAdminLogin && (
            <div className="space-y-2">
              <p className="text-sm text-purple-200/70">
                Ainda não é um membro certificado?
              </p>
              <button
                onClick={() => navigate('/work')}
                className="text-sm text-purple-300 hover:text-purple-200 transition-colors"
              >
                Trabalhe Conosco →
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};